import { updateIsRead } from "../PojedinaObavijest/api/updateIsRead";
import { deleteNotification } from "./api/deleteNotification";
import { getUsersNotifications } from "./api/getUsersNotifications";

export const organizeNotificationsByMonth = (notifications) => {
  const organizedNotifications = {};

  notifications.forEach((notification) => {
    const timePosted = new Date(notification.createdAt);
    const monthName = new Intl.DateTimeFormat("en-US", {
      month: "long",
    }).format(timePosted);
    const monthYearKey = `${monthName}-${timePosted.getFullYear()}`;

    if (!organizedNotifications[monthYearKey]) {
      organizedNotifications[monthYearKey] = [];
    }

    organizedNotifications[monthYearKey].push(notification);
  });

  return organizedNotifications;
};

export const handleCheckboxChange = (
  selectedNotificationIDs,
  id,
  setSelectedNotificationIDs
) => {
  let updatedRows;
  const isSelected = selectedNotificationIDs.includes(id);
  updatedRows = isSelected
    ? selectedNotificationIDs.filter((rowId) => rowId !== id)
    : [...selectedNotificationIDs, id];
  setSelectedNotificationIDs(updatedRows);
};
export const handleToggleSelectAll = (
  notifications,
  selectedNotificationIDs,
  setSelectedNotificationIDs
) => {
  const allIds = notifications.map((item) => item?.id);
  const isAllSelected = selectedNotificationIDs.length === allIds.length;

  if (isAllSelected) {
    setSelectedNotificationIDs([]);
  } else {
    setSelectedNotificationIDs([...allIds]);
  }
};

export const fetchNotifications = async (
  userData,
  authToken,
  setNotifications
) => {
  const response = await getUsersNotifications(userData?.id, authToken);
  const res = response.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  setNotifications(res);
};

export const handleMarkAsReadOrDelete = async (
  setIsLoading,
  selectedNotificationIDs,
  authToken,
  setUserData,
  userData,
  setNotifications,
  setSelectedNotificationIDs,
  actionType
) => {
  try {
    setIsLoading(true);
    const apiCall =
      actionType === "read"
        ? updateIsRead(selectedNotificationIDs, authToken)
        : deleteNotification(selectedNotificationIDs, authToken);
    const response = await apiCall;
    if (response.status === 200) {
      if (actionType === "read") {
        setUserData((prevUserData) => ({
          ...prevUserData,
          notificationsCount:
            prevUserData.notificationsCount - selectedNotificationIDs.length,
        }));
      }
      fetchNotifications(userData, authToken, setNotifications);
      setSelectedNotificationIDs([]);
      setIsLoading(false);
    }
  } catch (error) {
    console.error("Error in saving notifications:", error);
  }
};
export const handleButtonDropdown = (setButtonDropdown, buttonDropdown) => {
  setButtonDropdown(!buttonDropdown);
};
